import { render, staticRenderFns } from "./IconSpeechBubbleAlt.vue?vue&type=template&id=23735472&"
import script from "./IconSpeechBubbleAlt.vue?vue&type=script&lang=js&"
export * from "./IconSpeechBubbleAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports